module.exports = __webpack_public_path__ + "img/bul_info_theme.1037c650.svg";